import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import ReportMerchantHeader from "../../components/Report/ReportMerchantHeader";
import ReportMerchantTable from "../../components/Report/ReportMerchantTable";
import { ToastMessage } from "../../components/ToastMessage";
import { getFormattedMerchantReportData } from "../../helper";
import { addAdminRefundRequest } from "../../services/disputeService";
import { getMerchantTransaction } from "../../services/transactionService";

const ReportMerchant = () => {
  const [approveConfirmationModal, setApproveConfirmationModal] =
    useState(false);
  const [responseData, setResponseData] = useState<any>([]);
  const [totalReports, setTotalReports] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [merchantDetail, setMerchantDetail] = useState({
    id: "",
    name: "",
  });
  const { id } = useParams();
  const LIMIT = 10;
  const [isTransactionEmpty, setIsTransactionEmpty] = useState(true);
  const [query, setQuery] = useState("");
  const [date, setDate] = useState(new Date());
  const [transactionSelected, setTransactionSelected] = useState("");
  const [isTableLoading, setTableLoading] = useState(false);
  const [dispute, setDispute] = useState({
    customerId: "",
    amount_qar: "",
    t_id: "",
  });
  const [filterData, setFilterData] = useState(false);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const fetchMerchantReportData = async (
    activePage: number,
    limitCount: number,
    id: string | undefined,
    date: Date | string,
    query: string,
    transactionSelected: string
  ) => {
    setTableLoading(true);
    try {
      const response = await getMerchantTransaction(
        activePage,
        limitCount,
        id,
        query,
        dayjs(date).format("YYYY-MM-DD"),
        transactionSelected
      );
      setTableLoading(false);
      const updatedData = getFormattedMerchantReportData(
        response.data.data.transactions
      );
      setResponseData(updatedData);
      setTotalReports(response.data.count);
      setMerchantDetail({
        id: response.data.data.merchant._id,
        name: response.data.data.merchant.name,
      });
      if (updatedData.length > 0) setIsTransactionEmpty(false);
    } catch (error: any) {
      setTableLoading(false);
      if (navigator.onLine) {
        setIsError(true);
        setErrorMessage({
          heading: "Error!",
          subHeading: error.message,
        });
      }
    }
  };

  useEffect(() => {
    fetchMerchantReportData(
      currentPage,
      LIMIT,
      id,
      date,
      query,
      transactionSelected
    );
  }, [currentPage, id, query]); // eslint-disable-line

  useEffect(() => {
    if (filterData === true) {
      fetchMerchantReportData(
        currentPage,
        LIMIT,
        id,
        date,
        query,
        transactionSelected
      );
    }
  }, [filterData]); // eslint-disable-line

  const handleCreateDispute = async (data: any) => {
    setDispute(data);
    setApproveConfirmationModal(true);
  };

  const handleDisputeCall = async () => {
    let data = {
      transId: dispute.t_id,
      amount: dispute.amount_qar,
      comments: "",
    };
    try {
      let response = await addAdminRefundRequest(data);
      if (response.status === 200) {
        setApproveConfirmationModal(false);
        fetchMerchantReportData(
          currentPage,
          LIMIT,
          id,
          date,
          query,
          transactionSelected
        );
      }
    } catch (error: any) {
      toast.error(<ToastMessage message={error.message} />, {
        hideProgressBar: true,
      });
    }
  };

  const handleSearch = (value: any) => {
    setQuery(value);
  };

  const handleDateChange = (value: any) => {
    setDate(value);
  };

  const handleTransactionSelected = (e: any) => {
    setTransactionSelected(e.target.value);
  };

  return (
    <ReportPageContainer>
      <ReportMerchantHeader
        id={merchantDetail.id}
        name={merchantDetail.name}
        isTransactionEmpty={isTransactionEmpty}
        onSearchChange={handleSearch}
        query={query}
        onDateChange={handleDateChange}
        date={date}
        handleTransactionSelected={handleTransactionSelected}
        setFilterData={setFilterData}
        transactionSelected={transactionSelected}
      />
      <ReportMerchantTable
        onPageChange={(page) => handlePageChange(page)}
        totalData={totalReports}
        currentPage={currentPage}
        rowsPerPage={LIMIT}
        data={responseData}
        isTableDataLoading={isTableLoading}
        onDispute={handleCreateDispute}
      />
      {isError && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsError}
          onSubmit={() => setIsError(false)}
        />
      )}
      {approveConfirmationModal && (
        <ConfirmModal
          heading="Confirm Dispute Resolution"
          subHeading={`Are you sure that you want to Dispute ${dispute.amount_qar} QAR for Customer ID ${dispute?.customerId}?`}
          button1Label="Cancel"
          button2Label="Yes"
          button1Submit={() => setApproveConfirmationModal(false)}
          button2Submit={handleDisputeCall}
          setOpenOrClose={() =>
            setApproveConfirmationModal(!approveConfirmationModal)
          }
        />
      )}
    </ReportPageContainer>
  );
};

export default ReportMerchant;

const ReportPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
